import { BILLING_COLUMN_TYPE } from '~/modules/common/enums';

export const initialState = ({
  id,
  defaultInvoicePaymentTerm,
  billLineItemsBy,
  invoiceCurrency,
  description,
  internalNotes,
  showComments,
  poNumber
}) => ({
  id,
  defaultInvoicePaymentTerm,
  billLineItemsBy: billLineItemsBy || [BILLING_COLUMN_TYPE.PROJECT],
  invoiceCurrency,
  description: description || null,
  internalNotes: internalNotes || null,
  showComments: showComments || false,
  poNumber
});

const useFormState = ({
  id,
  defaultInvoicePaymentTerm,
  billLineItemsBy,
  invoiceCurrency,
  description,
  internalNotes,
  showComments,
  poNumber
}) => {
  const initialValues = initialState({
    id,
    defaultInvoicePaymentTerm,
    billLineItemsBy,
    invoiceCurrency,
    description,
    internalNotes,
    showComments,
    poNumber
  });

  return {
    initialValues
  };
};

export default useFormState;
